const { localizedLinkProps } = require("./navigation");

const supportedLocales = new Set(["en", "nl-be", "tr-tr"]);
const attributes = record => record?.attributes || record;
const recordSlug = record => {
  const data = attributes(record);
  return data?.slug_overwrite || data?.Slug || data?.slug;
};

// A relation may reference English content inside another language's page.
// Only select a translation actually supplied by the CMS; otherwise keep that record.
function contentRecordHref(record, prefix, preferredLocale) {
  const data = attributes(record);
  if (!data) return null;
  const variants = [data, ...(data.localizations?.data || []).map(attributes)];
  const valid = variants.filter(item => {
    const slug = recordSlug(item);
    return item?.publishedAt !== null && supportedLocales.has(item?.locale?.toLowerCase()) &&
      typeof slug === "string" && slug.length > 0 && !/[/?#]/.test(slug);
  });
  const selected = valid.find(item => item.locale.toLowerCase() === preferredLocale?.toLowerCase()) ||
    valid.find(item => item === data);
  if (!selected) return null;
  return `/${selected.locale.toLowerCase()}${prefix}/${recordSlug(selected)}`;
}

// Generic CMS page buttons sometimes store the internal slug, not slug_overwrite.
// Extract only a single page reference; external URLs and nested paths are untouched.
function pageLinkReference(href, locale) {
  if (!href || /^(?:[a-z][a-z\d+.-]*:|\/\/|[?#])/i.test(href)) return null;
  const props = localizedLinkProps(href.startsWith("/") ? href : `/${href}`, locale);
  const match = props.href.match(/^\/([^/?#]+)([?#].*)?$/);
  if (!match || !supportedLocales.has(props.locale)) return null;
  return { slug: match[1], locale: props.locale, suffix: match[2] || "" };
}

module.exports = { contentRecordHref, pageLinkReference };
